//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.selections

import blazern.lexisoup.graphql.model.type.ClientConfig
import blazern.lexisoup.graphql.model.type.GraphQLInt
import blazern.lexisoup.graphql.model.type.GraphQLString
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CompiledSelection
import com.apollographql.apollo.api.notNull
import kotlin.collections.List

public object ClientConfigQuerySelections {
  private val __config: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "backendRedirectionUrl",
          type = GraphQLString.type
        ).build(),
        CompiledField.Builder(
          name = "minQueryLength",
          type = GraphQLInt.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "maxQueryLength",
          type = GraphQLInt.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "translateTextLengthMax",
          type = GraphQLInt.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "translateTextLengthMin",
          type = GraphQLInt.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "translateBatchSizeLimit",
          type = GraphQLInt.type.notNull()
        ).build()
      )

  public val __root: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "config",
          type = ClientConfig.type.notNull()
        ).selections(__config)
        .build()
      )
}
